import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

import Dropdown from "components/Dropdown";

import WithFormField from "../WithFormField";

const normalizeInput = (inputArray) => {
  if (inputArray.length === 0) {
    return inputArray;
  }

  const lastElement = inputArray.pop();
  const newArray = lastElement
    .trim()
    .split(",")
    .map((value) => {
      return value.trim();
    })
    .filter((value) => {
      return value !== "" && !inputArray.includes(value);
    });

  return [...inputArray, ...newArray];
};

export function ControlledCreatableInput({
  name,
  initialValue,
  required,
  errorMessage,
  placeholder,
  addOnSpace,
  ...props
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name: name,
    defaultValue: initialValue || [],
    rules: { required: { value: required, message: errorMessage } },
  });

  return (
    <Dropdown
      multiple
      freeSolo
      clearOnBlur
      options={[]}
      open={false}
      value={field.value}
      error={Boolean(error)}
      placeholder={field?.value?.length > 0 ? "" : placeholder}
      onBlur={(e) => {
        if (
          e.target.value.trim() !== "" &&
          !field.value.includes(e.target.value.trim())
        ) {
          field.value.push(e.target.value.trim());
          field.onChange(normalizeInput(field.value));
        }

        field.onBlur(e);
      }}
      onChange={(_, values) => {
        field.onChange(normalizeInput(values));
      }}
      onKeyDown={(e) => {
        if (e.keyCode === 32 && addOnSpace) {
          e.defaultMuiPrevented = true;
          e.preventDefault();

          if (
            e.target.value.trim() !== "" &&
            !field.value.includes(e.target.value.trim())
          ) {
            field.value.push(e.target.value.trim());
            field.onChange(normalizeInput(field.value));
          } else {
            e.target.value = "";
          }
        }
      }}
      {...props}
    />
  );
}

ControlledCreatableInput.propTypes = {
  name: PropTypes.string,
  initialValue: PropTypes.arrayOf(PropTypes.string),
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  addOnSpace: PropTypes.bool,
};

ControlledCreatableInput.defaultProps = {
  initialValue: [],
  name: "creatable-input",
  required: false,
  errorMessage: "",
  placeholder: "Enter a value",
  addOnSpace: false,
};

export default WithFormField(ControlledCreatableInput);
